import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	PostOurDoctorMessage,
	PostOurDoctorMessageParams,
	PostOurDoctorMessageResponse,
} from 'domain/usecases/private/home/post-our-doctor-message';

export class RemotePostOurDoctorMessage implements PostOurDoctorMessage {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostOurDoctorMessageResponse>,
	) {}

	async post(params: PostOurDoctorMessageParams): Promise<PostOurDoctorMessageResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			case HttpStatusCode.forbidden:
				throw new APIError(httpResponse.status, httpResponse.data);
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
